import { useCallback, useState } from "react"
import { useAppContext } from "~/app.use-app-context.hook"
import {
  isLoading,
  match,
  withFailure,
  withSuccess,
} from "~/store/async-store.utils"
import { Currency } from "./currency.model"

type State = {
  currencies: Currency[]
  isLoading: boolean
  error: string | null
}

export const useCurrenciesStore = () => {
  const {
    currenciesModule: { service, store },
  } = useAppContext()
  const [state, setState] = useState<State>({
    currencies: withSuccess(store.state, [], ({ currencies }) => currencies),
    isLoading: isLoading(store.state),
    error: withFailure(store.state, null, (error) => error),
  })

  store.addListener(
    match({
      onInitial: () => {
        setState({
          currencies: [],
          isLoading: false,
          error: null,
        })
      },
      onLoading: () => {
        setState({ ...state, isLoading: true })
      },
      onFailure: (error) => {
        setState({ ...state, error, isLoading: false })
      },
      onSuccess: ({ currencies }) => {
        setState({ currencies, isLoading: false, error: null })
      },
    }),
  )

  const fetchCurrencies = useCallback(async () => {
    await service.fetchAll()
  }, [service])

  return {
    state,
    actions: { fetchCurrencies },
  }
}
